import React, { FC } from 'react'
import { Badge, Icon } from '@wmgtech/legato'


import { cn } from 'shared/utils'
import { formatDate } from 'shared/utils/formatDate'
import { userFullName } from 'shared/utils/userFullName'

import styles from './storyInfo.module.scss'
import { StoryInfoProps } from './StoryInfo.props'

export const StoryInfo: FC<StoryInfoProps> = ({ story, projectId, isSquare = false }) => {
  const isUpdated = story.updated_at !== story.created_at && story?.lastEditor?.email
  const isManuallyCreated = !!story.author

  return (
    <div className={cn(styles.storyInfo, { [styles.isSquare]: isSquare })}>
      <div className={styles.dates}>
        {isUpdated ? (
          <div className={styles.item}>
            <Icon name="pen" />
            &nbsp;
            {formatDate({ date: story.updated_at })}
            &nbsp;by&nbsp;
            <a className={styles.link} href={`mailto:${story?.lastEditor?.email}`}>
              {story?.lastEditor ? userFullName(story.lastEditor) : null}
            </a>
          </div>
        ) : null}

        <div className={styles.item}>
          <Icon name="archive" />
            &nbsp;
          {formatDate({ date: story.created_at })}
          {isManuallyCreated ? (
            <>
                &nbsp;by&nbsp;
              <a className={styles.link} href={`mailto:${story.author?.email}`}>
                {story?.author ? userFullName(story.author) : null}
              </a>
            </>
          ) : null}
        </div>

        {!projectId ? (
          <div className={styles.item}>
            <Icon name="circle-dot" />
            &nbsp;
            {story?.campaign?.unit?.name}
          </div>
        ) : null}
      </div>
      <div className={styles.tags}>
        {story?.tags?.map((tag) => (
          <Badge key={tag.id} className={styles.tag} containerStyle="outline" colorType="dark" text={tag.label || ''} size="xs" />
        ))}
      </div>
    </div>
  )
}
